import { type FC } from 'react'
import { ProgressBar } from '@lib/components'

export enum Step {
  Select = 'Select',
  Split = 'Split',
  Qurbani = 'Qurbani',
  Extras = 'Extras',
  Checkout = 'Checkout',
}

const stepOrder: Record<string, number> = {
  Select: 0,
  Split: 1,
  Extras: 2,
  Checkout: 3
}

const stepOrderWithQurbani: Record<string, number> = {
  Select: 0,
  Split: 1,
  Qurbani: 2,
  Extras: 3,
  Checkout: 4
}

const bgColours = {
  completed: 'bg-mtd-secondary-3',
  incomplete: 'bg-mtd-gray-4',
  current: 'bg-mtd-blue-1'
}

const textColours = {
  completed: 'text-mtd-secondary-3',
  incomplete: 'text-mtd-gray-4',
  current: 'text-mtd-blue-1'
}

export const CheckoutProgressBar: FC<{ step: Step, withQurbani?: boolean }> = ({ step, withQurbani = false }) => {
  const steps = withQurbani ? stepOrderWithQurbani : stepOrder
  return <ProgressBar totalSteps={steps[Step.Checkout] + 1} currentStep={steps[step]} bgColours={bgColours} textColours={textColours} showStepCount={false} />
}
